import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="border-t border-[var(--border-hair)] bg-[var(--surface)] mt-24">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-4">
                        <img src={LOGO_URL} alt="Logo" className="h-24 w-24 object-contain" />
                        <div>
                            <div className="font-display font-black text-2xl uppercase tracking-tight">
                                Motorcycle<span className="text-[#E87722]">routes</span>
                            </div>
                            <div className="font-display font-bold text-sm uppercase tracking-[0.28em] text-[var(--fg-muted)] mt-1">
                                Ireland
                            </div>
                        </div>
                    </div>
                    <p className="mt-6 text-[var(--fg-muted)] max-w-md leading-relaxed">
                        A curated field guide to Ireland's greatest motorcycle roads —
                        peninsula loops, mountain passes and the full Wild Atlantic Way.
                        Built by riders, for riders.
                    </p>
                    <div className="mt-6 flex gap-3">
                        {[
                            { icon: Instagram, label: "instagram" },
                            { icon: Facebook, label: "facebook" },
                            { icon: Youtube, label: "youtube" },
                            { icon: Mail, label: "email" },
                        ].map(({ icon: Icon, label }) => (
                            <a
                                key={label}
                                data-testid={`footer-social-${label}`}
                                href="#"
                                className="w-10 h-10 border border-[var(--border-hair)] flex items-center justify-center text-[var(--fg-muted)] hover:text-[#E87722] hover:border-[#E87722] transition-colors"
                            >
                                <Icon size={16} />
                            </a>
                        ))}
                    </div>
                </div>

                <div>
                    <div className="eyebrow mb-4">Explore</div>
                    <ul className="space-y-2 font-body text-[var(--fg-muted)]">
                        <li><Link data-testid="footer-link-routes" to="/routes" className="hover:text-[#E87722]">All Routes</Link></li>
                        <li><Link data-testid="footer-link-destinations" to="/destinations" className="hover:text-[#E87722]">Destinations</Link></li>
                        <li><Link data-testid="footer-link-about" to="/about" className="hover:text-[#E87722]">About</Link></li>
                        <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-[#E87722]">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="eyebrow mb-4">Regions</div>
                    <ul className="space-y-2 font-body text-[var(--fg-muted)]">
                        <li><Link data-testid="footer-region-kerry" to="/destinations/kerry" className="hover:text-[#E87722]">Kerry</Link></li>
                        <li><Link data-testid="footer-region-connemara" to="/destinations/connemara" className="hover:text-[#E87722]">Connemara</Link></li>
                        <li><Link data-testid="footer-region-donegal" to="/destinations/donegal" className="hover:text-[#E87722]">Donegal</Link></li>
                        <li><Link data-testid="footer-region-antrim" to="/destinations/antrim" className="hover:text-[#E87722]">Antrim Coast</Link></li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-[var(--border-hair)]">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-[var(--fg-dim)] font-body">
                    <div>&copy; {new Date().getFullYear()} MotorcycleRoutesIreland.com — Ride with respect.</div>
                    <div className="uppercase tracking-[0.2em]">Kinsale · Malin Head · Everything in between</div>
                </div>
            </div>
        </footer>
    );
};
